module.exports = __webpack_public_path__ + "static/media/IMG-12.73bb0852.jpg";